// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button[data-v-1c9b5a04]:disabled {\n  background-color: #000;\n  cursor: not-allowed;\n}\nbutton[data-v-1c9b5a04]:disabled:hover {\n  background-color: #000;\n  opacity: .5;\n}\n.spinner[data-v-1c9b5a04] {\n  left: calc(50% - 8px);\n  top: calc(50% - 8px);\n  position: absolute;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
